import { animate, AnimationTriggerMetadata, style, transition, trigger } from '@angular/animations';

export function loaderIndicator(): AnimationTriggerMetadata {
  return trigger('loaderIndicator', [
    transition('* => void', [animate('.4s ease-in-out', style({ opacity: 0, transform: 'scaleX(1)' }))]),
  ]);
}
